import {PageTitle} from '@hconnect/uikit/src/lib2'
import {Button} from '@hm/fundamental'
import {mdiCheck} from '@mdi/js'
import {Stack} from '@mui/material'
import React from 'react'

import {useWidgetTranslation} from '../hooks'

import {BackToLink} from './BackToLink'

export type ChecklistPageHeaderProps = {
  title?: string
  backButtonProps?: {
    targetName: string
    target: string
    onNavigate?: (target: string) => void
  }
  afterTitle?: React.ReactNode
  actions?: React.ReactNode
  onSubmitClick?: () => void
  isSubmitting?: boolean
}

export const ChecklistPageHeader = React.memo<ChecklistPageHeaderProps>(
  ({title, backButtonProps, onSubmitClick, isSubmitting = false}) => {
    const {t} = useWidgetTranslation()

    return (
      <>
        <Stack
          direction={{xs: 'column', sm: 'row'}}
          justifyContent={'space-between'}
          flexWrap="wrap"
          mb={{xs: 2, sm: 3}}
          gap={1}
        >
          <Stack mr="auto">
            {backButtonProps && <BackToLink {...backButtonProps} />}
            <PageTitle
              mx={3}
              mb={!backButtonProps ? 2 : 0}
              sx={{display: 'inline-flex', alignItems: 'center'}}
              data-test-id="page-title"
              color="primary.contrastText"
            >
              {title}
            </PageTitle>
          </Stack>
          <Stack direction="row" spacing={1}>
            {onSubmitClick && (
              <Button
                size="regular"
                icon={mdiCheck}
                onClick={onSubmitClick}
                disabled={isSubmitting}
                data-test-id="checklist-header-submit-button"
              >
                {t('button.submitChecklist')}
              </Button>
            )}
          </Stack>
        </Stack>
      </>
    )
  }
)
